// Compare viewport coordinates, not offsetTop: message rows are positioned
// ancestors, so their date markers' offsets are local to individual messages.
export function visibleChatDate(markers: ArrayLike<Element>, container: HTMLElement): string {
 const top=container.getBoundingClientRect().top+container.clientTop;
 let selected: Element | undefined;
 for(let i=0;i<markers.length;i++) {
  const marker=markers[i];
  if(!selected || marker.getBoundingClientRect().top<=top) selected=marker;
  else break;
 }
 return selected?.textContent?.trim() || '';
}
